export const fetchSettings = async userScopedFetch => {
    const response = await userScopedFetch(
        `${process.env.REACT_APP_API_ROOT}settings`, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const fetchProviders = async userScopedFetch => {
    const response = await userScopedFetch(
        `${process.env.REACT_APP_API_ROOT}provider`, {
            method: 'GET'
        }
    );

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const fetchProviderAuthUrl = async (provider, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        provider.authUrl, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const fetchSpaces = async userScopedFetch => {
    const response = await userScopedFetch(
        `${process.env.REACT_APP_API_ROOT}space`, {
            method: 'GET'
        }
    );

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const fetchConnections = async spaceScopedFetch => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}connection`, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
};

export const fetchConnectionReauthUrl = async (connectionUri, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${connectionUri}/reauth`, {
            method: 'GET'
        }
    );

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
};

export const fetchAccounts = async spaceScopedFetch => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}account`, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const runMagicAiSearch = async (search, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}magic-ai-search`, {
            method: 'POST',
            body: JSON.stringify({
                search
            })
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

const buildTransactionsQS = (filters) => {
    const { activeAccount, ...otherFilters } = filters;
    const qs = Object.entries(otherFilters).map(([key, value]) => ([ key, value ]));
    filters.activeAccounts.forEach(activeAccountUri => qs.push([
        "active_accounts", activeAccountUri
    ]));
    return qs
}

export const fetchTransactions = async (filters, url, spaceScopedFetch) => {
    if(!url) {
        url = `${process.env.REACT_APP_API_ROOT}transaction?${new URLSearchParams(buildTransactionsQS(filters)).toString()}`;
    }
    const response = await spaceScopedFetch(
        url, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const fetchTransactionSummary = async (filters, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}transaction/summary?${new URLSearchParams(buildTransactionsQS(filters)).toString()}`, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const downloadTransactions = async (filters, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}transaction/download?${new URLSearchParams(buildTransactionsQS(filters)).toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'text/csv'
            }
        }
    );

    if(!response) {
        return;
    }
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const contentDisposition = response.headers.get('Content-Disposition') || '';
    const matches = /filename="(.+)"/.exec(contentDisposition);
    const suggestedName = matches ? matches[1] : 'transactions.csv';
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = suggestedName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(link.href);
}

export const saveTransaction = async (transactionUri, data, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        transactionUri, {
            method: 'PUT',
            body: JSON.stringify(data)
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
}

export const getBulkTransactionCategories = async (filters, delta, spaceScopedFetch) => {
    const uri = `${process.env.REACT_APP_API_ROOT}transaction/all/bulk-summary?${new URLSearchParams(buildTransactionsQS(filters)).toString()}`;

    const response = await spaceScopedFetch(
        uri, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const bulkSaveTransactionCategories = async (allTransactions, filters, delta, toAdd, toRemove, spaceScopedFetch) => {
    let uri;
    if(allTransactions) {
        uri = `${process.env.REACT_APP_API_ROOT}transaction/all/bulk-summary?${new URLSearchParams(buildTransactionsQS(filters)).toString()}`;
    } else {
        if(filters) {
            throw Error()
        }
        uri = `${process.env.REACT_APP_API_ROOT}transaction/bulk-summary`;
    }
    const response = await spaceScopedFetch(
        uri, {
            method: 'POST',
            body: JSON.stringify({
                to_add: toAdd,
                to_remove: toRemove,
                delta: delta
            })
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
};

export const fetchCategories = async spaceScopedFetch => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}category`, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const saveCategories = async (categories, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}category`, {
            method: 'PUT',
            body: JSON.stringify(categories)
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const fetchRules = async spaceScopedFetch => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}rule`, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const saveRule = async (rule, apply, uri, spaceScopedFetch) => {
    let method = "PUT";
    if(!uri) {
        uri = `${process.env.REACT_APP_API_ROOT}rule`;
        method = "POST";
    }
    const response = await spaceScopedFetch(
        uri, {
            method,
            body: JSON.stringify({ ...rule, apply })
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
};

export const deleteRule = async (uri, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        uri, {
            method: "DELETE"
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
};

export const fetchChartRender = async (start, end, activeAccounts, config, spaceScopedFetch) => {
    if(!activeAccounts) {
        throw new Error("Active accounts must be provided for chart rendering.");
    }
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}render-chart`, {
            method: 'POST',
            body: JSON.stringify({
                start: start?.toISOString().split('T')[0],
                end: end?.toISOString().split('T')[0],
                activeAccounts,
                config
            })
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
};

export const fetchDashboardCards = async (spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}dashboard-card`, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const saveDashboardCards = async (cards, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${process.env.REACT_APP_API_ROOT}dashboard-card`, {
            method: 'PUT',
            body: JSON.stringify(cards)
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
}

export const fetchTransactionSplit = async (transactionUri, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${transactionUri}/split`, {
            method: 'GET'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
};

export const saveTransactionSplit = async (transactionUri, splitData, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${transactionUri}/split`, {
            method: 'PUT',
            body: JSON.stringify(splitData)
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
};

export const deleteTransactionSplit = async (transactionUri, spaceScopedFetch) => {
    const response = await spaceScopedFetch(
        `${transactionUri}/split`, {
            method: 'DELETE'
        }
    );

    if(!response) {
        return;
    }

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
};

// LLM Chat API
export const sendChatMessage = async (spaceScopedFetch, message) => {
    const response = await spaceScopedFetch(`${process.env.REACT_APP_API_ROOT}llm-chat/message`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message })
    });

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
};

export const loadChatConversation = async (spaceScopedFetch) => {
    const response = await spaceScopedFetch(`${process.env.REACT_APP_API_ROOT}llm-chat/conversation`, {
        method: 'GET'
    });

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
};

export const startNewChatConversation = async (spaceScopedFetch) => {
    const response = await spaceScopedFetch(`${process.env.REACT_APP_API_ROOT}llm-chat/new`, {
        method: 'POST'
    });

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    return await response.json();
};


